import { render, staticRenderFns } from "./PackageConfig.html?vue&type=template&id=4802b974&"
import script from "./PackageConfig.vue?vue&type=script&lang=js&"
export * from "./PackageConfig.vue?vue&type=script&lang=js&"
import style0 from "./PackageConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports